import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import "./style.css";
import { inventoryData } from "./data/inventory-data";
import { addMatadorConnectScript } from "./helpers";

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  display: block;
  overflow-y: auto;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 30px;
`;

const Title = styled.h1`
  color: #333;
`;

const FiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
`;

const Filter = styled.select`
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
`;

const SearchInput = styled.input`
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 250px;
`;

const CarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 20px;
`;

const CarCard = styled.div`
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
`;

const CarImage = styled.div`
  height: 200px;
  background-color: #f5f5f5;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
`;

const CarInfo = styled.div`
  padding: 15px;
`;

const CarTitle = styled.h3`
  margin: 0 0 8px 0;
  color: #333;
`;

const CarPrice = styled.div`
  font-weight: bold;
  font-size: 18px;
  color: #2c6b9c;
`;

const CarSpecs = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  color: #666;
  font-size: 14px;
`;

const ViewDetailsButton = styled.button`
  background-color: #2c6b9c;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  margin-top: 10px;
  cursor: pointer;
  width: 100%;

  &:hover {
    background-color: #1e5380;
  }
`;

const Inventory = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    addMatadorConnectScript();
  }, []);

  const filteredCars = inventoryData.filter((car) => {
    const matchesFilter = filter === "all" || car.type === filter;
    const matchesSearch =
      car.make.toLowerCase().includes(searchTerm.toLowerCase()) ||
      car.model.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  const handleCarClick = (car) => {
    navigate(`/demo-details?vin=${car.vin}`, { state: { car } });
  };

  return (
    <Container>
      <Header>
        <Title>Matador Motors Inventory</Title>
      </Header>

      <FiltersContainer>
        <Filter value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="all">All Types</option>
          <option value="sedan">Sedan</option>
          <option value="suv">SUV</option>
          <option value="truck">Truck</option>
          <option value="electric">Electric</option>
          <option value="luxury">Luxury</option>
        </Filter>

        <SearchInput
          type="text"
          placeholder="Search by make or model..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </FiltersContainer>

      <CarGrid>
        {filteredCars.map((car) => (
          <CarCard key={car.id} onClick={() => handleCarClick(car)}>
            <CarImage src={car.imageUrl || ""} />
            <CarInfo>
              <CarTitle>
                {car.year} {car.make} {car.model}
              </CarTitle>
              <CarPrice>${car.price.toLocaleString()}</CarPrice>
              <CarSpecs>
                <span>Year: {car.year}</span>
                <span>Mileage: {car.mileage.toLocaleString()} mi</span>
              </CarSpecs>
              <ViewDetailsButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleCarClick(car);
                }}
              >
                View Details
              </ViewDetailsButton>
            </CarInfo>
          </CarCard>
        ))}
      </CarGrid>
    </Container>
  );
};

export default Inventory;
